import { render, staticRenderFns } from "./MAgenteNotificacionQuickEditForm.vue?vue&type=template&id=72a2969d"
import script from "./MAgenteNotificacionQuickEditForm.vue?vue&type=script&lang=js"
export * from "./MAgenteNotificacionQuickEditForm.vue?vue&type=script&lang=js"
import style0 from "./MAgenteNotificacionQuickEditForm.vue?vue&type=style&index=0&id=72a2969d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports